import { useEffect } from "react";
import * as ga from "../../../lib/google-analytics";
import * as gtag from "../../../lib/google-tag-manager";
import * as fbq from "../../../lib/fb-pixel-analytics";
const Analytics = ({
  router
}) => {
  useEffect(() => {
    // This pageview only triggers the first time (it's important for Pixel to have real information)
    fbq.pageview();
    const handleRouteChange = url => {
      ga.pageview(url);
      gtag.pageview(url);
      fbq.pageview();
    };
    router.events.on('hashChangeComplete', handleRouteChange);
    return () => {
      router.events.off('hashChangeComplete', handleRouteChange);
    };
  }, [router.events]);
  return null;
};
export default Analytics;